/* eslint @typescript-eslint/ban-ts-comment: 0 */

/**
 * the two ts-ignore's below will be fixed in v9 of react-spring which is not
 * released yet.
 *
 * https://github.com/pmndrs/react-spring/issues/723
 */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Slider, { SliderProps } from 'rc-slider';
import { useSprings, animated, interpolate } from 'react-spring';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';

type Props = {
  className?: string;
  disabled?: boolean;
  userRating: number;
  submitRating: (value: number) => void;
};

export const RatingSlider = (props: Props) => {
  const { className, disabled, userRating, submitRating } = props;

  const animateMarks = (markIndex: number) => (index: number): { y: number; scale: number } =>
    index === markIndex ? { y: -6, scale: 1.6 } : { y: -2, scale: 1 };

  const [springs, setSprings] = useSprings(10, animateMarks(userRating ? -1 : userRating - 1));
  const [activeValue, setActiveValue] = useState(userRating === null ? 0 : userRating);
  const [hasSetRating, setHasSetRating] = useState<boolean | null>(null);

  useEffect(() => {
    if (userRating !== null && userRating !== 0 && hasSetRating === null) {
      setActiveValue(userRating);
      // @ts-ignore ¯\_(ツ)_/¯
      setSprings(animateMarks(userRating - 1));
    }
  }, [setSprings, setActiveValue, userRating, hasSetRating]);

  const handleOnAfterChange = (value: number) => {
    setHasSetRating(true);
    submitRating(value);
  };

  const handleOnChange = (value: number) => {
    const index = value - 1;
    setActiveValue(value);
    // @ts-ignore ¯\_(ツ)_/¯
    setSprings(animateMarks(index));
  };

  const ratingHandle: SliderProps['handle'] = (handleProps) => (
    <FontAwesomeIcon icon={faStar} style={{ left: `${handleProps.offset}%` }} className="star" />
  );

  const renderMark = () => (
    <div className="mark-wrap">
      {springs.map(({ y, scale }, i) => (
        <animated.span
          className={`mark-text ${activeValue === i + 1 ? 'active' : ''}`}
          key={i} // eslint-disable-line react/no-array-index-key
          style={{
            left: `${(i + 1) * 10}%`,
            transform: interpolate([y, scale], (y, scale) => `translate3d(-50%,${y}px,0) scale(${scale})`),
          }}
        >
          {i + 1}
        </animated.span>
      ))}
    </div>
  );

  return (
    <div className={className}>
      <Slider
        min={0}
        max={10}
        defaultValue={activeValue}
        value={activeValue}
        handle={ratingHandle}
        marks={{
          0: '',
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: 5,
          6: 6,
          7: 7,
          8: 8,
          9: 9,
          10: 10,
        }}
        trackStyle={{ backgroundColor: '#f9d083' }}
        onChange={(value) => {
          handleOnChange(value);
        }}
        onAfterChange={(value) => {
          handleOnAfterChange(value);
        }}
        disabled={disabled}
      />
      {renderMark()}
    </div>
  );
};

export const StyledRatingSlider = styled(RatingSlider)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 200px;

  .rc-slider {
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 2;
  }

  .rc-slider-disabled {
    background-color: transparent;
  }

  .rc-slider-dot-active,
  .rc-slider-dot {
    background-color: ${(props) => props.theme.primary1};
    border: none;
    border-radius: 0px;
    width: 1px;
    height: 8px;
    margin: 0px;
  }

  .rc-slider-mark {
    top: -22px;
    opacity: 0;
    z-index: 1;
  }

  .mark-wrap {
    top: -22px;
    height: 30px;
    position: absolute;
    left: 0;
    width: 100%;
    font-size: 1rem;
    z-index: 0;
  }

  .mark-text {
    position: absolute;
    cursor: pointer;
  }

  & .star {
    position: absolute;
    color: #ffc307;
    top: -2px;
    margin-left: -5%;
    z-index: 3;
    font-size: 1.43rem;
    max-width: 25px;
  }

  & .trash {
    left: 0px;
    z-index: 2;
    width: 25px;
    position: absolute;
    margin: 0px 0px 0px -12px;
    color: ${(props) => props.theme.primary4};
    font-size: 1.15rem;
    pointer-events: none;
    opacity: 0 !important; // disabling show trash for now
  }
`;
